/**
 * 财务--》出纳审核
*/

export default {
    handle_repeat_date: ["77357", "83139"], // 202506121731085103581, 从左到右调数据，超过50条会存在重复，添加js处理重复数据
    // 历史问题修复(客户现付核销,按时间升序排序有问题, 需要调整扩大分页pageSize参数)，灰度放量 
    hx_right_grid_use_size_1000: ["93101", "89772"], // 202508211641165935136
}

 